import axios from "axios";

const api = axios.create({
  // baseURL: "https://simplebooks.expeditetechhealth.com.au/api", // Relative path since frontend is served from backend
  baseURL: "/api", // Relative path since frontend is served from backend
});

// Attach JWT token if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
